import * as braintree from 'braintree-web';

declare global {
  interface Window {
    DocumentTouch?: () => unknown;
    ENV: {
      sentry: { dsn: string | null };
      flash: { notice: string | null; alert: string | null };
      translations: {
        en: Record<string, unknown>;
        de: Record<string, unknown>;
      };
      vat: { taxRate: number; countryCodes: string[] };
      studentLicensePrice: number;
      typeTesters: { minFontSize: number; maxFontSize: number };
    };
    braintree: {
      client: braintree.Client;
      payPal: braintree.PayPal;
      payPalCheckout: braintree.PayPalCheckout;
      threeDSecure: braintree.ThreeDSecure;
    };
  }
}

import 'styles/application.scss';

import { createRoot } from 'react-dom/client';

import Application from 'components/Application';

import * as Sentry from '@sentry/react';

if (window.ENV.sentry.dsn != null) {
  Sentry.init({
    dsn: window.ENV.sentry.dsn,
    maxBreadcrumbs: 50,
    tracesSampleRate: 0.25,
    profilesSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
    ],
  });
}

const container = document.getElementById('application');

if (container != null) {
  const root = createRoot(container);
  root.render(<Application />);
}

window.addEventListener('DOMContentLoaded', () => {
  if (
    'ontouchstart' in window ||
    (window.DocumentTouch && document instanceof window.DocumentTouch)
  ) {
    if (document.body != null) {
      document.body.classList.add('touch-device');
    }
  }
});
